import { render, staticRenderFns } from "./RubyDialog.vue?vue&type=template&id=23a907c1&scoped=true&"
import script from "./RubyDialog.vue?vue&type=script&lang=ts&"
export * from "./RubyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RubyDialog.vue?vue&type=style&index=0&id=23a907c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a907c1",
  null
  
)

export default component.exports